<form class="checkout-payment-options-form" [formGroup]="form">
    <div class="payer-name">
        <div class="checkout-payment-options-form__field">
            <p class="body-1" [class.invalid-control]="firstNameControl.errors">First name</p>

            <mat-form-field appearance="outline">
                <input
                    id="firstName"
                    class="body-0"
                    formControlName="firstName"
                    libTrimmedValue
                    matInput
                    placeholder="First Name"
                    [ariaLabel]="labels.firstName"
                    [ariaPlaceholder]="labels.firstName"
                />
                @if (firstNameControl.errors) {
                    <mat-error aria-live="assertive" role="alert">
                        <mat-icon svgIcon="ico_alert" />
                        Tell us the cardholder's first name as it appears on the card.
                    </mat-error>
                }
            </mat-form-field>
        </div>
        <div class="checkout-payment-options-form__field">
            <p class="body-1" [class.invalid-control]="lastNameControl.errors">Last name</p>
            <mat-form-field appearance="outline">
                <input
                    id="lastName"
                    class="body-0"
                    formControlName="lastName"
                    libTrimmedValue
                    matInput
                    placeholder="Last Name"
                    [ariaLabel]="labels.lastName"
                    [ariaPlaceholder]="labels.lastName"
                />
                @if (lastNameControl.errors) {
                    <mat-error aria-live="assertive" role="alert">
                        <mat-icon svgIcon="ico_alert" />
                        Tell us the cardholder's last name as it appears on the card.
                    </mat-error>
                }
            </mat-form-field>
        </div>
    </div>
    <div class="checkout-payment-options-form__field">
        <p class="body-1" [class.invalid-control]="isSubmitTouched() && !isNumberFieldValid()">Card number</p>
        <div class="form-control" [class.invalid]="isSubmitTouched() && !isNumberFieldValid()" #numberContainer></div>

        @if (!isNumberFieldValid() && isSubmitTouched()) {
            <mat-error aria-live="assertive" role="alert">
                <mat-icon svgIcon="ico_alert" />
                Card number is invalid
            </mat-error>
        }
    </div>

    <div class="checkout-payment-options-form__row">
        <div class="checkout-payment-options-form__expiration">
            <p
                class="body-1"
                [class.invalid-control]="isSubmitTouched() && (expMonthControl.errors || expYearControl.errors)"
            >
                Expiration
            </p>
            <div class="checkout-payment-options-form__expiration-fields">
                <mat-form-field appearance="outline">
                    <input
                        class="body-0"
                        #monthTrigger="matAutocompleteTrigger"
                        formControlName="expMonth"
                        libTrimmedValue
                        matInput
                        placeholder="Month"
                        readonly
                        [matAutocomplete]="monthAuto"
                        (click)="monthTrigger.openPanel()"
                        (focus)="monthTrigger.openPanel()"
                    />
                    <mat-autocomplete
                        #monthAuto="matAutocomplete"
                        aria-label="Input Month of expiration on your card"
                        autoActiveFirstOption
                    >
                        @for (option of monthOptions; track option) {
                            <mat-option [ariaLabel]="optionMonthAriaLabel(option)" [value]="option">
                                {{ option }}
                            </mat-option>
                        }
                    </mat-autocomplete>

                    @if (isSubmitTouched() && expMonthControl.errors?.required) {
                        <mat-error aria-live="assertive" role="alert">
                            <mat-icon svgIcon="ico_alert" />
                            Choose month.
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <input
                        id="expYear"
                        class="body-0"
                        #yearTrigger="matAutocompleteTrigger"
                        formControlName="expYear"
                        matInput
                        placeholder="Year"
                        readonly
                        [matAutocomplete]="yearAuto"
                        (click)="yearTrigger.openPanel()"
                        (focus)="yearTrigger.openPanel()"
                    />
                    <mat-autocomplete
                        #yearAuto="matAutocomplete"
                        aria-label="Input Year of expiration on your card"
                        autoActiveFirstOption
                    >
                        @for (option of yearOptions; track option) {
                            <mat-option [ariaLabel]="optionYearAriaLabel(option)" [value]="option">{{
                                option
                            }}</mat-option>
                        }
                    </mat-autocomplete>

                    @if (isSubmitTouched() && expYearControl.errors?.required) {
                        <mat-error aria-live="assertive" role="alert">
                            <mat-icon svgIcon="ico_alert" />
                            Choose year.
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="checkout-payment-options-form__field">
            <p class="body-1" [class.invalid-control]="isSubmitTouched() && !isSecurityCodeFieldValid()">
                Security Code
            </p>
            <div
                class="form-control form-control--security-code"
                [class.invalid]="isSubmitTouched() && !isSecurityCodeFieldValid()"
                #securityCodeContainer
            ></div>

            @if (isSubmitTouched() && !isSecurityCodeFieldValid()) {
                <mat-error aria-live="assertive" role="alert">
                    <mat-icon svgIcon="ico_alert" />
                    Tell us a valid security code.
                </mat-error>
            }
        </div>
    </div>
</form>
